import { EventEmitter, Component, ChangeDetectorRef, Optional, Inject, Input, Output, NgModule } from '@angular/core';
import '@angular/forms';
import { AbpBaseConstant } from '@colibrium/abp-base';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion functional/model imports
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function AbpValidationDisplayComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(ctx_r0.config.errorTextClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.message);
} }
class AbpValidationDisplayConstant extends AbpBaseConstant {
}
AbpValidationDisplayConstant.validationDisplayConfigInjectKey = 'validation-display-config';
if (false) {
    /** @type {?} */
    AbpValidationDisplayConstant.validationDisplayConfigInjectKey;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion functional/model imports
class AbpValidationDisplayComponent {
    //#endregion model properties
    //#region constructor
    /**
     * @param {?} changeDetector
     * @param {?} validationConfig
     */
    constructor(changeDetector, validationConfig) {
        this.changeDetector = changeDetector;
        this.isSubmitted = false;
        this.isControlValid = new EventEmitter();
        this.isControlTouched = false;
        this.show = false;
        this.message = '';
        this.config = this.getConfigDefaults(validationConfig);
    }
    //#endregion constructor
    //#region component events
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        this.setValidationState();
        //Reset control if input changes
        if (changes.control && changes.control.previousValue != changes.control.currentValue && this.subscription) {
            this.subscription.unsubscribe();
        }
        if (this.control && this.control.statusChanges && (!this.subscription || this.subscription.closed)) {
            this.subscription = this.control.statusChanges.subscribe((/**
             * @return {?}
             */
            () => {
                this.changeDetector.detectChanges();
                this.setValidationState();
            }));
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    //#endregion component events
    //#region service calls
    //#endregion service calls
    //#region public functions/events assoaciated with UI elements
    //#endregion public functions/events assoaciated with UI elements
    //#region private functions
    /**
     * sets validation state
     * @private
     * @return {?}
     */
    setValidationState() {
        this.message = '';
        if (this.control) {
            this.isControlTouched = (this.control.dirty || this.control.touched || this.isSubmitted);
            /** @type {?} */
            let canValidate = this.config.showErrorOnSubmitOnly ? this.isSubmitted : this.isControlTouched;
            this.show = canValidate && !this.control.valid;
            if (canValidate) {
                if (this.show) {
                    this.setMessage();
                    this.isControlValid.emit(false);
                }
                else {
                    this.isControlValid.emit(true);
                }
            }
        }
    }
    /**
     * gets error message for display
     * @private
     * @return {?}
     */
    setMessage() {
        if (this.control.errors && this.validationMap) {
            /** @type {?} */
            let keys = Array.from(this.validationMap.keys());
            for (let key of keys) {
                if (this.control.errors[key]) {
                    this.message = this.validationMap.get(key);
                    break;
                }
            }
        }
    }
    /**
     * gets default values for configs
     * @private
     * @param {?} injectionModel
     * @return {?}
     */
    getConfigDefaults(injectionModel) {
        if (injectionModel) {
            return injectionModel;
        }
        /** @type {?} */
        let validationConfig = {
            errorControlClass: AbpValidationDisplayConstant.cssClass.abp_input_control_error,
            errorTextClass: AbpValidationDisplayConstant.cssClass.abp_error_text,
            showErrorOnSubmitOnly: false,
            successControlClass: AbpValidationDisplayConstant.cssClass.abp_input_control_valid
        };
        return validationConfig;
    }
}
AbpValidationDisplayComponent.ɵfac = function AbpValidationDisplayComponent_Factory(t) { return new (t || AbpValidationDisplayComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(AbpValidationDisplayConstant.validationDisplayConfigInjectKey, 8)); };
AbpValidationDisplayComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AbpValidationDisplayComponent, selectors: [["abp-validation-display"]], inputs: { isSubmitted: "isSubmitted", control: "control", validationMap: "validationMap" }, outputs: { isControlValid: "isControlValid" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[4, "ngIf"]], template: function AbpValidationDisplayComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, AbpValidationDisplayComponent_ng_container_0_Template, 3, 3, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.show);
    } }, directives: [ɵngcc1.NgIf], styles: [".validation-msg[_ngcontent-%COMP%]{color:#dc3545!important}"] });
/** @nocollapse */
AbpValidationDisplayComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [AbpValidationDisplayConstant.validationDisplayConfigInjectKey,] }] }
];
AbpValidationDisplayComponent.propDecorators = {
    control: [{ type: Input }],
    isSubmitted: [{ type: Input }],
    validationMap: [{ type: Input }],
    isControlValid: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AbpValidationDisplayComponent, [{
        type: Component,
        args: [{
                selector: 'abp-validation-display',
                template: "<ng-container *ngIf=\"show\">\r\n  <div [class]=\"config.errorTextClass\">{{message}}</div>\r\n</ng-container>\r\n",
                styles: [".validation-msg{color:#dc3545!important}"]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [AbpValidationDisplayConstant.validationDisplayConfigInjectKey]
            }] }]; }, { isSubmitted: [{
            type: Input
        }], isControlValid: [{
            type: Output
        }], control: [{
            type: Input
        }], validationMap: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    AbpValidationDisplayComponent.prototype.control;
    /** @type {?} */
    AbpValidationDisplayComponent.prototype.isSubmitted;
    /** @type {?} */
    AbpValidationDisplayComponent.prototype.validationMap;
    /** @type {?} */
    AbpValidationDisplayComponent.prototype.isControlValid;
    /** @type {?} */
    AbpValidationDisplayComponent.prototype.show;
    /** @type {?} */
    AbpValidationDisplayComponent.prototype.message;
    /** @type {?} */
    AbpValidationDisplayComponent.prototype.config;
    /**
     * @type {?}
     * @private
     */
    AbpValidationDisplayComponent.prototype.subscription;
    /**
     * @type {?}
     * @private
     */
    AbpValidationDisplayComponent.prototype.isControlTouched;
    /**
     * @type {?}
     * @private
     */
    AbpValidationDisplayComponent.prototype.changeDetector;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#region angular imports
//#endregion angular imports
//#region core imports
//#endregion core imports
//#region functional/model imports
//#endregion functional/model imports
/**
 * @record
 */
function AbpValidationDisplayConfigModel() { }
if (false) {
    /** @type {?} */
    AbpValidationDisplayConfigModel.prototype.errorTextClass;
    /** @type {?} */
    AbpValidationDisplayConfigModel.prototype.errorControlClass;
    /** @type {?} */
    AbpValidationDisplayConfigModel.prototype.successControlClass;
    /**
     * determines if error can be shown on form submit only. If false error message is shown if control is dirty or touched
     * @type {?}
     */
    AbpValidationDisplayConfigModel.prototype.showErrorOnSubmitOnly;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion components
//#region directives
//#endregion directives
//#region pipes/filter
//#endregion pipes/filters
//#region services
//#endregion services
//#region handlers/providers
//#endregion handlers/providers
class AbpValidationDisplayModule {
    /**
     * @param {?} config
     * @return {?}
     */
    static forRoot(config) {
        return (/** @type {?} */ ({
            ngModule: AbpValidationDisplayModule,
            providers: [
                { provide: AbpValidationDisplayConstant.validationDisplayConfigInjectKey, useValue: config },
            ]
        }));
    }
}
AbpValidationDisplayModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AbpValidationDisplayModule });
AbpValidationDisplayModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AbpValidationDisplayModule_Factory(t) { return new (t || AbpValidationDisplayModule)(); }, providers: [], imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AbpValidationDisplayModule, { declarations: function () { return [AbpValidationDisplayComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [AbpValidationDisplayComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AbpValidationDisplayModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    AbpValidationDisplayComponent
                ],
                exports: [
                    AbpValidationDisplayComponent
                ],
                providers: []
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AbpValidationDisplayComponent, AbpValidationDisplayConstant, AbpValidationDisplayModule };

//# sourceMappingURL=colibrium-abp-validation-display.js.map